<button pButton [label]="buttonLabel" class="w-6 reset-password" (click)="btnClick()"></button>

<p-dialog [header]="header" [(visible)]="showPopup" [style]="{width: '50vw'}">
    <form [formGroup]="resetPasswordGroup">
        <div class="pr-3">
            <div class="pt-3">
                <label translate>lbl_warning</label>
            </div>
            <div class="pt-3 justify-content-start">
                <label class="font-semibold label" translate>please_type_reset_to_confirm</label> <span class="required ml-1">*</span>
            </div>
            <div class="py-2 justify-content-start">
                <input class="w-full" formControlName="value" type="text" pInputText placeholder="Enter here" />
            </div>
            @if (resetPasswordGroup.controls.value.errors && (resetPasswordGroup.controls.value.dirty || resetPasswordGroup.controls.value.touched)) {
                <div class="form-errors">
                <div [hidden]="!resetPasswordGroup.controls.value.errors.required" class="text-err" translate>
                    <i class="error_outline"></i>
                    events.please_enter_value
                </div>
            </div>
            }
        </div>
    </form>
    <div class="flex py-2 pr-3 justify-content-end">
        <button pButton class="w-2 bg-white border-button mr-2 default-text-light-black-color cursor-pointer"
            [label]="'cancel' | translate" (click)="showPopup = false"></button>
        <button pButton class="border-round-sm reset-btn w-2" type="submit" [label]="'lbl_reset' | translate"  [disabled]="!resetPasswordGroup.valid" (click)="setValue()"></button>
    </div>
</p-dialog>